module.exports = __webpack_public_path__ + "images/emoji/ng.a3343bb7e7b32e73d503.png";